import { useIsLocalOpen } from '../../../utils/useIsLocalOpen';
import { onboardingShown } from '../../constants';

export const useIsOpenOnboarding = (inEnabled: boolean) => {
  const { isOpen, close } = useIsLocalOpen(onboardingShown);

  return { isOpenOnboarding: isOpen && inEnabled, closeOnboarding: close };
};
